import DOMPurify from 'dompurify';

export const sanitizeInput = (input: string): string => {
  // Remove any HTML tags and potentially dangerous content
  return DOMPurify.sanitize(input, {
    ALLOWED_TAGS: [], // Don't allow any HTML tags
    ALLOWED_ATTR: [], // Don't allow any HTML attributes
  }).trim();
};

export const validatePhoneNumber = (phone: string): boolean => {
  const phoneRegex = /^\+?[\d\s-()]{10,}$/;
  return phoneRegex.test(phone);
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};